import { useContext, useEffect, useState } from "react";
import { Button, ButtonGroup, Col, Row, Spinner, Table } from "react-bootstrap";
import { datatypelist, DATATYPE_BACKTOCHINA, DATATYPE_DOCUMENT, DATATYPE_BASIC, DATATYPE_SYSTEM, DATATYPE_CONTACT, DATATYPE_SCHOOL, FileName, FREEZE_FIELD, TITLE, DB_TITLE, colorCode } from "../databases/spName";
import { SelectForm } from "../components/FormItem";
import { AdminContext } from "../contexts/AdminContext";
import RenderFilters from "../components/RenderFilters";
import RenderUser from "../components/RenderUser";
import RenderStatistics from "../components/RenderStatistics";
import { UpdateFileStatus } from "../databases/files";



const PageDatabases = () => {

    const { users, filters, colorFilters, setColorFilter } = useContext(AdminContext)
    const [sortBy, setSortBy] = useState('')
    const [showType, setShowType] = useState('backtochina')

    useEffect(() => {
        
        return () => {
            setSortBy('')
            setShowType('backtochina')
        }
    }, [])

    useEffect(() => {
        const setType = (t) => setShowType(s => s === 'statistics' ? s : t)
        for (let i = 0; i < 3; i++) {
            if (filters[i].field && filters[i].value) {
                if (Object.keys(FileName).includes(filters[i].field)) setShowType(DATATYPE_DOCUMENT)
                else if (Object.keys(TITLE).filter(d => TITLE[d].datatype === DATATYPE_BASIC).includes(filters[i].field)) setType(DATATYPE_BASIC)
                else if (Object.keys(TITLE).filter(d => TITLE[d].datatype === DATATYPE_SCHOOL).includes(filters[i].field)) setType(DATATYPE_SCHOOL)
                else if (Object.keys(TITLE).filter(d => TITLE[d].datatype === DATATYPE_CONTACT).includes(filters[i].field)) setType(DATATYPE_CONTACT)
                else if (Object.keys(TITLE).filter(d => TITLE[d].datatype === DATATYPE_BACKTOCHINA).includes(filters[i].field)) setType(DATATYPE_BACKTOCHINA)
                else if (filters[i].field === 'role') setShowType(DATATYPE_SYSTEM)
            }
        }
    }, [filters])

    const TableHead = () => (
        <thead>
            <tr style={{fontSize : '14px'}}>
                <th>แก้ไข</th>
                {DB_TITLE.map((field, index) => (
                    <th 
                        key={index} 
                        hidden={showType !== TITLE[field].datatype && !FREEZE_FIELD.includes(field)} onClick={() => setSortBy(field)} 
                        className={sortBy === field ? 'bg-warning' : ''}
                    >
                        {TITLE[field].TH}
                        <br />
                        {TITLE[field].CN}
                    </th>
                ))}
                {['role', 'register', 'note'].map((field, index) => (
                    <th 
                        key={index} onClick={() => setSortBy(field)} 
                        className={sortBy === field ? 'bg-warning' : ''}
                        hidden={showType !== 'system'}
                    >
                        {TITLE[field].TH}
                    </th>
                ))}
                {Object.keys(FileName).map((field, index) => (
                    <th key={index} hidden={showType !== 'document'} onClick={() => setSortBy(field)} className={sortBy === field ? 'bg-warning' : ''}>
                        {TITLE[field].TH}
                        <br />
                        {TITLE[field].CN}
                    </th>
                ))}
            </tr>
        </thead>
    )

    const SortFunction = (a, b) => {
        const fa = users[a]
        const fb = users[b]
        if (fa && fa[sortBy] !== undefined && fb && fb[sortBy] !== undefined) {
            if (["", "-", 0, false].includes(fa[sortBy])) return 1;
            if (["", "-", 0, false].includes(fb[sortBy])) return -1;
            let c = fa[sortBy]
            let d = fb[sortBy]
            if (sortBy === 'flightIndex' && !isNaN(c) && !isNaN(d)) {
                c = parseInt(c)
                d = parseInt(d)
            }
            return c > d ? 1 : c < d ? -1 : 0 
        }
        else {
            return 0
        }
    }

    const TableBody = () => (
        <tbody>
            
            {[...Object.keys(users)].sort(SortFunction).map((keyname, index) => (
                <RenderUser key={index} keyname={keyname} user={users[keyname]} showType={showType} />
            ))}
        </tbody>
    )
    
    const [onLoading, setOnLoading] = useState(false)
    useEffect(() => {
        return () => setOnLoading(false)
    }, [])
    const onUpdateFileStatusClick = async () => {
        setOnLoading(true)
        try {
            for (const k in users) await UpdateFileStatus(k)
        }
        catch (e) {
            console.log(e)
        }
        finally {
            setOnLoading(false)
        }
    }

    return (
        <div>           
            <RenderFilters />

            <Row bsPrefix="row align-items-center">
                <Col bsPrefix="col-auto"><div className="bold">ข้อมูลสมาชิก</div></Col>
                <Col bsPrefix="col-auto">
                    <SelectForm noMargin={true} value={showType} onChange={e => setShowType(e.target.value)} options={{...datatypelist, statistics : 'สถิติ', system : 'ระบบ'}}/>
                </Col>
                <Col bsPrefix="col" />
                <Col bsPrefix="col-auto">
                    <div className="text-end">
                        <ButtonGroup >
                            {[...Object.keys(colorCode)].map((code, index) => (
                                <Button 
                                    style={{background : colorCode[code], border : !colorFilters[code] ? '1.6px solid red' : 'none', width : '30px', height : '30px'}} 
                                    name={code} onClick={e => setColorFilter(e.target.name)} key={index}
                                />
                            ))}
                        </ButtonGroup>
                    </div>
                    
                </Col>
                
            </Row>
            <div hidden={showType !== DATATYPE_DOCUMENT}><Button disabled={onLoading} onClick={onUpdateFileStatusClick}><Spinner animation="border" size='sm' hidden={!onLoading}/>ปุ่มทดสอบบัค กรุณาอย่ากดเล่น!!!</Button></div>
            <div style={{background : 'white'}}>
                <Table responsive striped bordered hover hidden={showType === 'statistics'}>
                    {TableHead()}
                    {TableBody()}
                </Table>
                {![...Object.keys(users)].length ? 
                        <div className="text-danger" style={{padding : '20px'}}>
                            <h5>อัปเดตแพตช์ใหม่</h5>
                            <div>- เพิ่มหมายเหตุ ในปุ่มแก้ไขได้ เช่น ติดโควิด</div>
                            <div>- เพิ่มฟิลเตอร์สี ด้านบนตาราง</div>
                            <hr />
                            <h5>แพตช์ที่แล้ว</h5>
                            <div>- เลือก <span className='bold'>ประเภทผู้ใช้งาน</span> ได้ ดังนี้ </div>
                            <div style={{paddingLeft : '20px'}}>{`->`} ลงทะเบียนใหม่ : ไม่เกี่ยวกับเหมาลำ เก็บข้อมูลคนที่มาจีนเฉย ๆ</div>
                            <div style={{paddingLeft : '20px'}}>{`->`} เที่ยวบินเหมาลำ : รายชื่อเดิม ผ่านการคัดกรองกูเกิลฟอร์มป่านมาแล้ว</div>
                            <div>- ข้อมูลจะยังไม่ขึ้นทันที โปรดเลือกตัวกรองข้างบนอย่างน้อย 1 ชุด เช่น เที่ยวบิน จากนั้นกดค้นหา</div>
                            <div>- เมื่อต้องการข้อมูลที่อัปเดต โปรดกดค้นหาอีกรอบ</div>
                            <div>- สามารถค้นหาคนที่ยังไม่ส่ง/ส่งเอกสารได้แล้ว โดยเลือกตัวกรองเป็นชื่อเอกสาร</div>
                            <div>- สามารถค้นหาทั้งหมด โดยเลือกเที่ยวบิน และเลือกทั้งหมด</div>
                            
                        </div>
                    : <></>}
                <div hidden={showType !== 'statistics'}>
                    <RenderStatistics />
                </div>
            </div>

            <br />
        </div>
    )
}

export default PageDatabases ;